export enum ScheduleKind {
    MESSAGE = 'MESSAGE',
    MUSIC = 'MUSIC',
    SCENT = 'SCENT',
    VIDEO = 'VIDEO'
};

export enum ScheduleShaker {
    ALTERNATED = 'ALTERNATED',
    CHAINED = 'CHAINED',
    DISTRIBUTED = 'DISTRIBUTED',
    EXCLUSIVE = 'EXCLUSIVE',
    MIXED = 'MIXED',
    WEIGHTED = 'WEIGHTED'
};

export enum EventStrategy {
    DELETE = 'DELETE',
    UNSCHEDULE = 'UNSCHEDULE'
};

export enum EventAttachment {
    PLANNING = 'PLANNING',
    SPOT = 'SPOT',
    UNATTACHED = 'UNATTACHED'
};